var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHoriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0722656,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5342 21C14.2592 21 14.0238 20.9021 13.8279 20.7063C13.6321 20.5104 13.5342 20.275 13.5342 20C13.5342 19.725 13.6321 19.4896 13.8279 19.2938C14.0238 19.0979 14.2592 19 14.5342 19C14.8092 19 15.0446 19.0979 15.2404 19.2938C15.4363 19.4896 15.5342 19.725 15.5342 20C15.5342 20.275 15.4363 20.5104 15.2404 20.7063C15.0446 20.9021 14.8092 21 14.5342 21ZM20.0727 21C19.7977 21 19.5623 20.9021 19.3664 20.7063C19.1706 20.5104 19.0727 20.275 19.0727 20C19.0727 19.725 19.1706 19.4896 19.3664 19.2938C19.5623 19.0979 19.7977 19 20.0727 19C20.3477 19 20.5831 19.0979 20.7789 19.2938C20.9748 19.4896 21.0727 19.725 21.0727 20C21.0727 20.275 20.9748 20.5104 20.7789 20.7063C20.5831 20.9021 20.3477 21 20.0727 21ZM25.6112 21C25.3362 21 25.1008 20.9021 24.9049 20.7063C24.7091 20.5104 24.6112 20.275 24.6112 20C24.6112 19.725 24.7091 19.4896 24.9049 19.2938C25.1008 19.0979 25.3362 19 25.6112 19C25.8862 19 26.1216 19.0979 26.3174 19.2938C26.5133 19.4896 26.6112 19.725 26.6112 20C26.6112 20.275 26.5133 20.5104 26.3174 20.7063C26.1216 20.9021 25.8862 21 25.6112 21Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHoriz);
export default __webpack_public_path__ + "static/media/more_horiz.af74f4032aae097e05e01851e0891897.svg";
export { ForwardRef as ReactComponent };